import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BankingAalytics } from "../../icons/dashboard/bankingAnalytics.svg";
import { ReactComponent as ConsumptionAndGenerationAnalytics } from "../../icons/dashboard/consumptionAndGenerationAnalytics.svg";
import { ReactComponent as DemandForecasting } from "../../icons/dashboard/demandForecasting.svg";
import { ReactComponent as ExchangeAnalysis } from "../../icons/dashboard/exchangeAnalysis.svg";
import { ReactComponent as GridFrequencyProfile } from "../../icons/dashboard/gridFrequencyProfile.svg";
import { ReactComponent as PowerAtlas } from "../../icons/dashboard/powerAtlas.svg";
import { ReactComponent as Upload } from "../../icons/upload.svg";
import { ReactComponent as Download } from "../../icons/download.svg";
import { ReactComponent as DashboardIcon } from "../../icons/dashboard.svg";
import { ReactComponent as DashboardSelectedIcon } from "../../icons/dashboard-selected.svg";
import { ReactComponent as RajAgentIcon } from "../../icons/gnai.svg";
import { ReactComponent as RajAgentSelectedIcon } from "../../icons/gnai-active.svg";
import { COLOR_CODES, isMobile } from "../../common";
import { GridcoTitle } from "./components";
import Hamburger from "../../components/Hamburger";
import { IconTab } from "../../components/IconTab";
import { PageHeader } from "../../components/Page";

export const TabSwitcher: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Read the current 'tab' query parameter from the URL.
  // Default to "dashboard" if no tab is specified.
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get("tab") || "dashboard";

  // When a tab is clicked, update the URL accordingly.
  const handleTabChange = (newTab: string) => {
    navigate(`/gridco?tab=${newTab}`);
  };

  return (
    <div className="flex flex-row gap-x-2 items-center">
      <IconTab
        tabs={[
          { key: "dashboard", icon: DashboardIcon, selectedIcon: DashboardSelectedIcon },
          // { key: "vidyutai", icon: RajAgentIcon, selectedIcon: RajAgentSelectedIcon },
        ]}
        selected={tab}
        onChange={handleTabChange}
      />
      {tab === "vidyutai" && !isMobile && (
        <h1 className="text-[18px] text-[#6F6D7C]">Vidyut AI</h1>
      )}
    </div>
  );
};

export function GridcoDashboardItem({
  title,
  Icon,
  to,
}: {
  title: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  to: string;
}) {
  return (
    <NavLink to={`${to}`} className="dashboard-item">
      <Icon
        width={80}
        height={33}
        style={{
          fill: COLOR_CODES.primary,
        }}
      />
      <p>{title}</p>
    </NavLink>
  );
}

export default function GridcoDashboard() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedTab = searchParams.get("tab") || "dashboard";

  return (
    <>
      <div className="page-wrapper">
        <PageHeader
          leftComponent={
            <div className="flex flex-row md:gap-x-4 gap-x-2 items-center">
              {!isMobile && <Hamburger />}
              <TabSwitcher />
            </div>
          }
          middleComponent={!isMobile ? <GridcoTitle /> : undefined}
        />

        <div className="dashboard-item-container">
          <div className="flex flex-col justify-between h-full">
            <div className="flex flex-row flex-wrap gap-5 justify-center">
              <GridcoDashboardItem
                Icon={PowerAtlas}
                title="Overview"
                to="compare"
              />
              <GridcoDashboardItem
                Icon={DemandForecasting}
                title="Demand Analytics"
                to="demand"
              />
              <GridcoDashboardItem
                Icon={ConsumptionAndGenerationAnalytics}
                title="Generation Analytics"
                to="genration"
              />
              <GridcoDashboardItem
                Icon={ExchangeAnalysis}
                title="Power Procurement"
                to="procurement"
              />
              <GridcoDashboardItem
                Icon={ExchangeAnalysis}
                title="Exchange Analytics"
                to="exchangeAnalysis"
              />
              <GridcoDashboardItem
                Icon={BankingAalytics}
                title="GNA-TGNA Allocation Optimizer"
                to="optimizer"
              />

              <GridcoDashboardItem
                Icon={ExchangeAnalysis}
                title="PowerMarketizer"
                to="procurementOptimization"
              />
              <GridcoDashboardItem
                Icon={BankingAalytics}
                title="Merit Engine"
                to="merit_engine"
              />
              <GridcoDashboardItem
                Icon={Download}
                title="Download Data"
                to="download_data"
              />
              <GridcoDashboardItem
                Icon={Upload}
                title="Upload Data"
                to="upload"
              />
              <GridcoDashboardItem
                Icon={BankingAalytics}
                title="Automation"
                to="automation"
              />

              <GridcoDashboardItem
                Icon={GridFrequencyProfile}
                title="Transactions"
                to="#"
              />
            </div>
            <div className="gna-footer-container mt-8">
              <div className="grid grid-cols-3 justify-between items-center gap-5 ">
                <h3 className="text-[#9f9f9f] font-medium text-[13px]">
                  GNA Energy Data and Analytics Capability Center (GDACC)
                </h3>
                <p className="gna-footer-text text-center">
                  Powered by <strong>GNA Energy</strong>
                </p>
                <strong className="gna-footer-text  text-end">
                  Beta Version
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
